/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membersapproveall2Inputs */

const en_membersapproveall2 = /** @type {(inputs: Membersapproveall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept all`)
};

const de_membersapproveall2 = /** @type {(inputs: Membersapproveall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle annehmen`)
};

/**
* | output |
* | --- |
* | "Accept all" |
*
* @param {Membersapproveall2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersapproveall2 = /** @type {((inputs?: Membersapproveall2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersapproveall2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersapproveall2(inputs)
	return de_membersapproveall2(inputs)
});
export { membersapproveall2 as "membersApproveAll" }